import ComponentStructure from '../basic'

export default class I18nForLwToolbar extends ComponentStructure {
  name = 'lw-toolbar'
  properties = []

  getHtmlElement () {
    return null
  }

  getPropertyShownElement (property: string) {
    return null
  }

  getChildComponents () {
    return this.component.components || []
  }
}
